import { hasElements } from "Utils/Array";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { projectsDeleteDialog } from "../../../Store/Actions";
import { selectSelectedOrActiveProjects } from "../../../Store/Selectors/Projects";
import { IAction } from "./IAction";

export function useDelete(): [boolean, IAction] {
  const dispatch = useDispatch();
  const selectedProjects = useSelector(selectSelectedOrActiveProjects);
  const allowDelete = hasElements(selectedProjects) && selectedProjects.length <= 10;

  const onDelete = useCallback(() => {
    if (!allowDelete) {
      return;
    }

    dispatch(projectsDeleteDialog(true));
  }, [allowDelete, dispatch]);

  return [allowDelete, onDelete];
}
